import { cn } from "~/lib/utils";
import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// // // //

export function ScrollButton(props: {
    showDropShadow: boolean;
    onClick: () => void;
}) {
    const { showDropShadow, onClick } = props;

    const handleClick = () => {
        onClick();
    };

    return (
        <button
            className={cn(
                "min-w-44 hidden lg:flex items-center justify-between",
                "px-2 py-0.5 text-xs whitespace-nowrap",
                "rounded-md relative mr-4",
                "transition-all duration-150 ease-in-out",
                "outline-hidden ring-0",
                "bg-muted hover:bg-secondary/50",
                "border",
            )}
            onClick={handleClick}
            aria-label={showDropShadow ? "Scroll to end" : "Scroll to front"}
            role="button"
        >
            {/* Left chevron */}
            <ChevronLeft
                className={cn(
                    "h-3.5 w-3.5 transition-opacity duration-150 text-secondary-foreground",
                    showDropShadow ? "opacity-0" : "opacity-100",
                )}
                strokeWidth={1.5}
            />

            <span className="text-[10px] text-secondary-foreground uppercase tracking-widest">
                {showDropShadow ? "Scroll to end" : "Scroll to front"}
            </span>

            {/* Right chevron */}
            <ChevronRight
                className={cn(
                    "h-3.5 w-3.5 transition-opacity duration-150 tracking-wide text-secondary-foreground",
                    showDropShadow ? "opacity-100" : "opacity-0",
                )}
                strokeWidth={1.5}
            />
        </button>
    );
}
